// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__7fmGV","cell":"ColumnAccessor_cell__1X-4U","firstCellAccent":"ColumnAccessor_firstCellAccent__39fRh"};